<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b-card-title>Logo Countries</b-card-title>
      </b-card-header>
      <b-card-body class="pb-1">
        <b-card-text>
          <p>Logo for different countries</p>
        </b-card-text>
        <b-table-simple
          caption
          responsive
        >
          <b-tbody class="text-center country-logo-table">
            <b-tr>
              <b-th
                :class="isDark ? 'bg-darken' : 'bg-light'"
              >
                Malaysia
              </b-th>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/horizontal-logo-pink.svg')"
                  class="w-75"
                  alt="EasyParcel Malaysia Logo Horizontal"
                />
              </b-td>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/vertical-logo-pink.svg')"
                  class="w-75"
                  alt="EasyParcel Malaysia Logo Vertical"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-th
                :class="isDark ? 'bg-darken' : 'bg-light'"
              >
                Singapore
              </b-th>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/horizontal-logo-pink-sg.svg')"
                  class="w-75"
                  alt="EasyParcel Singapore Logo Horizontal"
                />
              </b-td>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/vertical-logo-pink-sg.svg')"
                  class="w-75"
                  alt="EasyParcel Singapore Logo Vertical"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-th
                :class="isDark ? 'bg-darken' : 'bg-light'"
              >
                Thailand
              </b-th>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/horizontal-logo-pink-th.svg')"
                  class="w-75"
                  alt="EasyParcel Thailand Logo Horizontal"
                />
              </b-td>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/vertical-logo-pink-th.svg')"
                  class="w-75"
                  alt="EasyParcel Thailand Logo Vertical"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-th
                :class="isDark ? 'bg-darken' : 'bg-light'"
              >
                Indonesia
              </b-th>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/horizontal-logo-pink-id.svg')"
                  class="w-75"
                  alt="EasyParcel Indonesia Logo Horizontal"
                />
              </b-td>
              <b-td>
                <b-img
                  :src="require('@/assets/images/logo/vertical-logo-pink-id.svg')"
                  class="w-75"
                  alt="EasyParcel Indonesia Logo Vertical"
                />
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import {
  BCard, BImg, BCardHeader, BCardTitle, BCardBody, BCardText, BTableSimple, BTr, BTbody, BTd, BTh,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    // BRow,
    // BCol,
    BImg,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BTableSimple,
    BTr,
    BTbody,
    BTd,
    BTh,
  },
  directives: {
    Ripple,
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')
    return { skin, isDark }
  },
}
</script>

<style>
.country-logo-table th, td {border: 1px solid #ebe9f1;}
</style>
